import React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import Text, { TextContent } from '@lightspeed/cirrus-text';
import { Button } from '@lightspeed/flame/Button';
import PropTypes from 'prop-types';

import { createReactRenderer } from 'helpers/react-renderer';

class CancelSaleDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleConfirm() {
    const { onConfirm } = this.props;

    this.setState(
      {
        isOpen: false,
      },
      onConfirm
    );
  }

  handleCancel() {
    const { onCancel } = this.props;

    this.setState(
      {
        isOpen: false,
      },
      onCancel
    );
  }

  render() {
    const { isOpen } = this.state;

    return (
      <Modal className="cirrus responsive" isOpen={isOpen} onRequestClose={this.handleConfirm}>
        <ModalHeader onCloseClicked={this.handleCancel}>Transaction Pending</ModalHeader>
        <ModalBody>
          <TextContent style={{ maxWidth: '24rem' }}>
            <Text bodySmall>
              To cancel the sale, you must first delete the transaction(s) on the payment page.
            </Text>
          </TextContent>
        </ModalBody>
        <ModalFooter>
          <Group className="cr-justify-end">
            <Button onClick={this.handleCancel}>Cancel</Button>
            <Button variant="primary" fill onClick={this.handleConfirm}>
              Go to Payment Page
            </Button>
          </Group>
        </ModalFooter>
      </Modal>
    );
  }
}

CancelSaleDialog.propTypes = {
  onConfirm: PropTypes.func,
};

CancelSaleDialog.defaultProps = {
  onConfirm: () => {},
};

// eslint-disable-next-line
let _cancelSaleDialog = null;
export const showCancelSaleDialog = (onConfirm = () => {}) => {
  const RenderedComponent = createReactRenderer({
    component: CancelSaleDialog,
    selector: '[data-react-root="ReactModal"]',
    props: {
      onConfirm: () => {
        onConfirm();
        _cancelSaleDialog = null;
        RenderedComponent.unmount();
      },

      onCancel: () => {
        _cancelSaleDialog = null;
        RenderedComponent.unmount();
      },
    },
  });
  _cancelSaleDialog = RenderedComponent.mount();
};

export default CancelSaleDialog;
